import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  description,
  url,
  image,
  type = "website",
}) => {
  return (
    <Helmet>
      {/* Primary SEO */}
      <title>{title}</title>
      {description && (
        <meta name="description" content={description} />
      )}
      {url && <link rel="canonical" href={url} />}
      <meta name="robots" content="index, follow" />

      {/* Open Graph */}
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      {description && (
        <meta property="og:description" content={description} />
      )}
      {url && <meta property="og:url" content={url} />}
      <meta property="og:site_name" content="Shootin School Basketball" />
      {image && (
        <>
          <meta property="og:image" content={image} />
          <meta property="og:image:alt" content={title} />
        </>
      )}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && (
        <meta name="twitter:description" content={description} />
      )}
      {image && (
        <meta name="twitter:image" content={image} />
      )}
    </Helmet>
  );
};

export default SEO;
